import {
  Box, Typography, FormControlLabel, Container, styled, Theme,
} from '@material-ui/core';

export const FlexContainer = styled(Container)({
  flex: 1,
});

export const HeaderBox = styled(Box)({
  marginTop: 32,
  marginBottom: 40,
});

export const Title = styled(Typography)({
  marginBottom: 8,
});

export const RequiredConsentLabel = styled(FormControlLabel)({
  marginTop: 24,
  marginBottom: 16,
  alignItems: 'flex-start',
});

export const OptionalConsentLabel = styled(FormControlLabel)({
  marginTop: 8,
  marginBottom: 32,
  alignItems: 'flex-start',
});

export const SocialButtonIconContainer = styled(Box)({
  position: 'absolute',
  left: 16,
  display: 'flex',
  alignItems: 'center',
});

export const DividerContainer = styled(Box)({
  position: 'relative',
  marginBottom: 24,
});

export const DividerText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.common.white,
  padding: '0 16px',
  color: theme.palette.text.primary,
  fontSize: 14,
}));

export const getSocialButtonStyles = (theme: Theme) => ({
  textTransform: 'none' as const,
  borderRadius: 100,
  backgroundColor: theme.palette.grey[50],
  borderColor: theme.palette.divider,
  color: theme.palette.grey[800],
  position: 'relative' as const,
});

export const continueButtonStyles = {
  marginBottom: 24,
  borderRadius: 100,
};
